import React from "react";
import "../FormTemplates.css";
import bg_template from "./OnboardingInfoTemplate.png";

export default function OnboardingInfoTemplate({ data, isDownload = false }) {
  // isDownload = true

  const downloadStyles = { fontSize: '14px' };
  const previewStyles = { fontSize: '9px' };

  return (
    <div className={isDownload ? "w4-wrapper-download" : "w4-wrapper-preview"} style={isDownload ? downloadStyles : previewStyles}>
      <img src={bg_template} alt="W4 Form" className="w4-bg" />

      {/* Example filled details */}
    <div className="overlay" style={isDownload ? { top: "120px", left: "140px" } : { top: "53px", left: "60px" }}>
        John Doe
      </div>
      <div className="overlay" style={ isDownload ? { top: "120px", left: "630px" } : { top: "53px", left: "285px" }}>
        123-45-6789
      </div>
      <div className="overlay" style={ isDownload ? { top: "182px", left: "140px" } : { top: "81px", left: "60px" }}>
        123 Main Street, New York, NY 10001
      </div>
    </div>
  );
}
